import React from 'react';
import { motion } from 'framer-motion';
import { Linkedin, Mail } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
const leaders = [{
  name: 'George Dreer',
  title: 'Founder and Principal',
  image: 'https://cdn.magicpatterns.com/uploads/eDmfQmfbn6rf3qBnGJA8dS/george.d.png',
  bio: "George Dreer brings extensive experience in global advisory and strategic partnerships across the natural resources sector. As President & CEO of Strategic Metals Group Inc., he leads the firm's mission to connect capital, commodities, and opportunity across international markets. His deep expertise in precious metals, mining finance, and cross-border transactions has positioned the firm as a trusted advisor to investors, mining companies, and commodity buyers worldwide.",
  expertise: ['Global Advisory & Strategic Partnerships', 'Precious Metals & Mining Finance', 'Cross-Border Transactions', 'Investor Relations', 'Off-Take Agreement Structuring'],
  linkedin: '#',
  email: 'george@strategicmetalsgroup.com'
}, {
  name: 'Adil Kassam',
  title: 'Founder and Principal',
  image: 'https://cdn.magicpatterns.com/uploads/9vDbNuGoZrEeAHzkLHQDBi/adil.k.png',
  bio: 'Adil Kassam is an experienced capital structures leader and entrepreneur with a background in fintech, real estate investment, and complex deal structuring. He previously exited a fintech company and served as Managing Director for Walton International in Alberta, Canada. He successfully structured REITs and developed pre-sales ventures for Edgeworth Properties during a period of significant growth. He later successfully exited Edebit Capital, a U.S. hedge fund with $1 billion in assets under management. His experience includes sophisticated real estate and capital structures across multiple markets.',
  expertise: ['Capital Structures & Deal Structuring', 'Fintech & Financial Innovation', 'Real Estate Investment (REITs)', 'Hedge Fund Management', 'Complex Transaction Execution'],
  linkedin: '#',
  email: 'adil@strategicmetalsgroup.com'
}];
export function LeadershipPage() {
  return <div className="w-full pt-36 lg:pt-44 bg-navy" data-id="element-367">
      {/* Hero */}
      <section className="bg-navy py-16 md:py-20" data-id="element-368">
        <div className="container mx-auto px-4 lg:px-8" data-id="element-369">
          <motion.div className="max-w-4xl mx-auto text-center" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-370">
            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4 md:mb-6" data-id="element-371">
              Leadership
            </h1>
            <div className="w-20 md:w-24 h-1 bg-gold-bar mx-auto mb-6 md:mb-8" data-id="element-372" />
            <p className="text-lg md:text-xl text-steel leading-relaxed max-w-2xl mx-auto" data-id="element-373">
              Experienced executives with deep expertise in capital markets,
              natural resources, and strategic partnerships.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Leadership Profiles */}
      <section className="bg-white py-16 md:py-20" data-id="element-374">
        <div className="container mx-auto px-4 lg:px-8" data-id="element-375">
          <div className="space-y-12 md:space-y-20" data-id="element-376">
            {leaders.map((leader, index) => <motion.div key={index} className="max-w-6xl mx-auto" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.2
          }} data-id="element-377">
                <Card className="border border-gold/20 overflow-hidden" data-id="element-378">
                  <CardContent className="p-0" data-id="element-379">
                    <div className="grid grid-cols-1 lg:grid-cols-5" data-id="element-380">
                      {/* Image */}
                      <div className="lg:col-span-2 relative bg-navy-light" data-id="element-381">
                        <img src={leader.image} alt={leader.name} className="w-full h-64 sm:h-80 lg:h-full object-cover object-top" data-id="element-382" />
                        <div className="absolute inset-0 bg-gradient-to-t from-navy/90 via-navy/30 to-transparent" data-id="element-383" />
                        <div className="absolute bottom-6 left-6 right-6 z-20" data-id="element-384">
                          <h2 className="font-heading text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-1" data-id="element-385">
                            {leader.name}
                          </h2>
                          <p className="text-lg md:text-xl text-gold font-semibold" data-id="element-386">
                            {leader.title}
                          </p>
                        </div>
                      </div>

                      {/* Content */}
                      <div className="lg:col-span-3 p-6 sm:p-8 lg:p-12 bg-ivory" data-id="element-387">
                        <div className="space-y-6 md:space-y-8" data-id="element-388">
                          {/* Bio */}
                          <div data-id="element-389">
                            <p className="text-charcoal leading-relaxed text-base md:text-lg" data-id="element-390">
                              {leader.bio}
                            </p>
                          </div>

                          {/* Expertise */}
                          <div data-id="element-391">
                            <h3 className="font-heading text-xl md:text-2xl font-semibold text-navy mb-3 md:mb-4" data-id="element-392">
                              Areas of Expertise
                            </h3>
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 md:gap-3" data-id="element-393">
                              {leader.expertise.map((area, i) => <div key={i} className="flex items-start space-x-2" data-id="element-394">
                                  <span className="text-gold mt-0.5 flex-shrink-0" data-id="element-395">
                                    •
                                  </span>
                                  <span className="text-charcoal text-sm md:text-base" data-id="element-396">
                                    {area}
                                  </span>
                                </div>)}
                            </div>
                          </div>

                          {/* Contact */}
                          <div className="pt-4 md:pt-6 border-t border-gold/20" data-id="element-397">
                            <div className="flex flex-wrap gap-3" data-id="element-398">
                              <Button asChild variant="outline" className="border-2 border-gold text-gold hover:bg-gold hover:text-navy text-sm md:text-base font-semibold gold-glow-subtle px-8 py-3" data-id="element-399">
                                <a href={leader.linkedin} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2" data-id="element-400">
                                  <Linkedin className="h-4 w-4" data-id="element-401" />
                                  LinkedIn Profile
                                </a>
                              </Button>
                              <Button asChild variant="outline" className="border-2 border-gold text-gold hover:bg-gold hover:text-navy text-sm md:text-base font-semibold gold-glow-subtle px-8 py-3" data-id="element-402">
                                <a href={`mailto:${leader.email}`} className="inline-flex items-center gap-2" data-id="element-403">
                                  <Mail className="h-4 w-4" data-id="element-404" />
                                  Contact
                                </a>
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="bg-navy py-16 md:py-20" data-id="element-405">
        <div className="container mx-auto px-4 lg:px-8" data-id="element-406">
          <motion.div className="max-w-4xl mx-auto" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-407">
            <h2 className="font-heading text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-4 md:mb-6 text-center" data-id="element-408">
              Our Leadership Principles
            </h2>
            <div className="w-20 md:w-24 h-1 bg-gold-bar mx-auto mb-8 md:mb-12" data-id="element-409" />
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-8" data-id="element-410">
              {[{
              title: 'Trust & Discretion',
              description: 'We handle all engagements with the highest level of confidentiality and professionalism.'
            }, {
              title: 'Strategic Thinking',
              description: 'We approach every opportunity with a long-term perspective and strategic mindset.'
            }, {
              title: 'Global Perspective',
              description: 'We leverage international experience and relationships to create cross-border value.'
            }, {
              title: 'Value Creation',
              description: 'We focus on delivering sustainable value for all stakeholders in every partnership.'
            }].map((principle, index) => <motion.div key={index} className="bg-navy-light border-l-4 border-gold p-5 md:p-6 rounded" initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} data-id="element-411">
                  <h3 className="font-heading text-lg md:text-xl font-semibold text-gold mb-2" data-id="element-412">
                    {principle.title}
                  </h3>
                  <p className="text-steel leading-relaxed text-sm md:text-base" data-id="element-413">
                    {principle.description}
                  </p>
                </motion.div>)}
            </div>
          </motion.div>
        </div>
      </section>
    </div>;
}